import { render } from "./HeroiconsSolidHeart.vue?vue&type=template&id=91bc4b7a"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidHeart.vue"]])

export default __exports__